import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllMadingActive = createAsyncThunk(
  "mading/GetAllMadingActive",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}mading/active?pageNumber=1&sortBy=created_at&sortType=DESC&pageSize=10`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllMading = createAsyncThunk(
  "mading/GetAllMading",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}mading/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleMading = createAsyncThunk(
  "mading/GetSingleMading",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}mading/content/${data.slug}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const madingSlice = createSlice({
  name: "mading",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all mading active
    builder.addCase(GetAllMadingActive.pending, loadingHandler);
    builder.addCase(GetAllMadingActive.fulfilled, fulfilledHandler);
    builder.addCase(GetAllMadingActive.rejected, rejectedHandler);
    // get all mading
    builder.addCase(GetAllMading.pending, loadingHandler);
    builder.addCase(GetAllMading.fulfilled, fulfilledHandler);
    builder.addCase(GetAllMading.rejected, rejectedHandler);
    // fetch mading by id
    builder.addCase(GetSingleMading.pending, loadingHandler);
    builder.addCase(GetSingleMading.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleMading.rejected, rejectedHandler);
  },
});

export const { reset } = madingSlice.actions;
export default madingSlice.reducer;
